import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import { getUserLocation } from "../../redux";
import { useGetAllUserData } from "../../hooks";
import { UsersTable } from "../../tables";
import { PageContent } from "../../components";
import { CreateEmployeeDialog, EditEmployeeDialog } from "../../dialogs";

import OrganizationUsersBar from "./OrganizationUsersBar";

export const OrganizationUsers = ({ defaultLocation = 1 }) => {
  const { search } = useLocation();
  const { refetch } = useGetAllUserData({ defaultLocation });
  const [id, setOpen] = useState(null);

  useEffect(() => {
    refetch();
  }, [search?.toString()]);

  const props = { id, setOpen, defaultLocation};

  return (
    <PageContent gap="10px" smallPadding hideOverflow>
      <OrganizationUsersBar {...props} />
      <UsersTable {...props} />
      <CreateEmployeeDialog />
      <EditEmployeeDialog id={id} setOpen={setOpen} />
    </PageContent>
  );
};

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});
export const OrganizationUsersContainer =
  connect(mapStateToProps)(OrganizationUsers);
export default OrganizationUsersContainer;
